import './nav-card.scss';

import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.js';
import { cn } from '@sola/ark-core/utils/helpers.js';

export const NavCardSkeleton = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'NavCard w-full max-w-sm mx-auto flex flex-cols items-center',
        className,
      )}
    >
      <div className="NavCard__media">
        <Skeleton
          width="124px"
          height="124px"
          style={{
            aspectRatio: 'square',
          }}
          className="NavCard__image"
        />
      </div>

      <div className="NavCard__content w-full">
        <div>
          <Skeleton height="2rem" width="60%" />
        </div>
        <div className="mt-snug-xl">
          <Skeleton height="1rem" width="90%" />
        </div>
        <div className="mt-snug-md">
          <Skeleton height="1rem" width="70%" />
        </div>
        <div className="mt-comfy-sm">
          <Skeleton height="1rem" width="20%" />
        </div>
      </div>
    </div>
  );
};
